<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->

    <div class="bookmark-wrapper align-items-center d-none d-lg-flex pr-1 border-right">
      <dark-Toggler class="d-none d-lg-block" />
    </div>
    <div class="align-items-center flex-grow-1"><AppBreadcrumb /></div>

    <!-- Indicador de modo mantenimiento (visible para el admin) -->
    <div
      v-if="maintenanceActive"
      class="maintenance-indicator d-flex align-items-center mr-1"
    >
      <feather-icon icon="ToolIcon" size="15" class="mr-50" />
      <span>Modo mantenimiento activo</span>
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <no-responsive />
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink, BNavbarNav,
} from 'bootstrap-vue'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import NoResponsive from '@core/layouts/components/app-navbar/components/NoResponsive.vue'
import UserDropdown from '@/@core/layouts/components/app-navbar/components/UserDropdown.vue'
import NotificationDropdown from '@/@core/layouts/components/app-navbar/components/NotificationDropdown.vue'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'

export default {
  components: {
    BLink,
    BNavbarNav,
    AppBreadcrumb,

    // Navbar Components
    DarkToggler,
    NoResponsive,
    NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    maintenanceActive() {
      return this.$store.state.maintenance.active
    },
  },
  watch: {
    maintenanceActive: {
      immediate: true,
      handler(val) {
        if (typeof document !== 'undefined') {
          document.body.classList.toggle('app-maintenance', !!val)
        }
      },
    },
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('app-maintenance')
    }
  },
}
</script>

<style>
/* Fondo del topbar cuando el mantenimiento está activo (solo lo ve el admin). */
body.app-maintenance .header-navbar {
  background-color: #ffb4b4 !important;
}
</style>

<style scoped>
.maintenance-indicator {
  background-color: #b71c1c;
  color: #fff;
  font-weight: 600;
  font-size: 0.8rem;
  border-radius: 1rem;
  padding: 0.25rem 0.75rem;
  white-space: nowrap;
}
</style>
